export enum TransactionsScopeEnum {
  OVERVIEW = 'Overview',
  TOKEN = 'Token',
  PAIR = 'Pair',
  ACCOUNT = 'Account',
}
